// extracted by mini-css-extract-plugin
export default {"wrapper":"YN-2fBG","container":"tTV87V1","title":"g9Si4re"};